// Desc: Private route for authenticated users
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { bouncy } from 'ldrs';
bouncy.register();

// ==============================|| PROTECTED ROUTE ||============================== //
const ProtectedRoute = ({ element }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    // Check if "accessToken" key is present in localStorage
    const accessToken = localStorage.getItem('accessToken');

    // Update isAuthenticated based on whether accessToken is present
    setIsAuthenticated(!!accessToken);

    // Clean up the effect
    return () => {
      // You might not need to clean up anything in this case
      // Since we're only reading from localStorage, there's no subscription or event listener to unsubscribe from
    };
  }, []); // Empty dependency array means this effect runs only once, similar to the previous useEffect

  // If isAuthenticated is still being determined, you can render a loading indicator or wait for the result
  if (isAuthenticated === null) {
    return (
      <div className="flex justify-center items-center fixed top-0 left-0 z-10 text-5xl overflow-x-hidden bg-white w-screen h-screen">
        <l-bouncy size="45" speed="1.75" color="black"></l-bouncy>
      </div>
    );
  }
  // console.log('isAuthenticated', isAuthenticated);
  return isAuthenticated ? element : <Navigate to="/" />; // If user is not logged in, redirect to login page
};

export default ProtectedRoute;
